import React from 'react';
import { connect } from '@gasbuddy/react';
import { FlexGrid } from '@gasbuddy/react-components';
import StationPropType from '../../../utils/prop-types/station';
import styles from './styles.css';
import StationProfileMap from '../../maps/station-profile';
import RowWithLabel from '../../row-with-label';

const ViewContent = ({ station }) => (
  <div className={styles.brandInfoWrapper}>
    <FlexGrid className={styles.gridContainer}>
      <FlexGrid.Column mobile={12} tablet={4} className={styles.gridColumn}>
        <div className={styles.container}>
          <RowWithLabel label="Address">
            {`${station.address.address}, ${station.address.city}, ${station.address.state}, ${station.address.zip}`}
          </RowWithLabel>
          <RowWithLabel label="Alternate Street Name">{station.address.address_alias}</RowWithLabel>
          <RowWithLabel label="Cross Street">{station.address.cross_street}</RowWithLabel>
          <RowWithLabel label="Phone Number">{station.phone_number}</RowWithLabel>
        </div>
      </FlexGrid.Column>
      <FlexGrid.Column key="Map" mobile={12} tablet={8} className={styles.gridColumn}>
        <StationProfileMap station={station} />
      </FlexGrid.Column>
    </FlexGrid>
  </div>
);

ViewContent.propTypes = {
  station: StationPropType,
};

ViewContent.defaultProps = {
  station: null,
};

const mapStateToProps = state => ({
  station: state.station,
});

export default connect(mapStateToProps)(ViewContent);
